import { createFileRoute } from "@tanstack/react-router"
import DesignSystemRadios from "~/pages/design-system/components/Radios"

export const Route = createFileRoute("/_auth/internal/design-system/components/radios")({
  staticData: { skipSkuStoreData: true },
  component: RouteComponent,
})

function RouteComponent() {
  return <DesignSystemRadios />
}
